(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-uniform"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('complete-uniform')) {
    customElements.define('complete-uniform', class extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh.bind(this);
        document.addEventListener('cart:update', this.refresh);
        if (this.dataset.pageType === 'product') document.addEventListener('variant:update', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }
      disconnectedCallback() {
        document.removeEventListener('cart:update', this.refresh);
        document.removeEventListener('variant:update', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
        this.controller?.abort();
      }
      async refresh(event) {
        if (event.type === 'pageshow' && !event.persisted) return;
        if (event.detail?.data?.didError) return;
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const current = this.querySelector('[data-uniform-content]');
        if (current) current.hidden = true;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        if (event.type === 'variant:update' && event.detail?.resource?.id) url.searchParams.set('variant', event.detail.resource.id);
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (controller.signal.aborted || !this.isConnected) return;
          const updated = html.querySelector('complete-uniform [data-uniform-content]');
          if (updated && current) current.replaceWith(updated);
        } catch (error) {
          if (error.name !== 'AbortError') this.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nn-new-arrivals"] && !Shopify.designMode) return;
  try {
    
(function () {
function setup(root) {
if(root.dataset.nnReady) return;
const dialog=root.querySelector('dialog');
if(!dialog || !dialog.showModal) return;
root.dataset.nnReady='true';
const content=dialog.querySelector('.nn-arrivals__dialog-content');
const heading=dialog.querySelector('h2');
let opener=null,original=null,oldOverflow='';
root.querySelectorAll('.nn-arrivals__marker').forEach(b=>b.hidden=false);
root.querySelectorAll('[data-nn-target]').forEach(b=>b.setAttribute('aria-haspopup','dialog'));
function open(id,trigger,index) {
const details=root.querySelector('[id="'+id+'"]');
if(!details) return;
const body=details.querySelector('.nn-arrivals__look-content');
if(!body) return;
opener=trigger; original=details;
heading.textContent=details.dataset.nnName;
body.querySelectorAll('[data-nn-index]').forEach(li=>{li.removeAttribute('data-nn-selected');if(li.dataset.nnIndex===index)li.setAttribute('data-nn-selected','');});
content.append(body);
oldOverflow=document.documentElement.style.overflow;
document.documentElement.style.overflow='hidden';
dialog.showModal();
dialog.querySelector('.nn-arrivals__close').focus();
if(index)body.querySelector('[data-nn-selected]')?.scrollIntoView({block:'nearest'});
}
root.addEventListener('click',event=>{
const trigger=event.target.closest('[data-nn-target]');
if(trigger){event.preventDefault();open(trigger.dataset.nnTarget,trigger,trigger.dataset.nnPiece);return;}
const summary=event.target.closest('.nn-arrivals__look>summary');
if(summary){event.preventDefault();open(summary.parentElement.id,summary);}
});
dialog.querySelector('.nn-arrivals__close').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
dialog.addEventListener('close',()=>{if(original&&content.firstElementChild)original.append(content.firstElementChild);document.documentElement.style.overflow=oldOverflow;opener?.focus();});
}
document.querySelectorAll('[data-nn-looks]').forEach(setup);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-nn-looks]').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();
})();
